import EdgToast from '@aedifica/ui-components/src/components/EdgToast'

export default {
  install(Vue) {
    const edgToastInstance = new (Vue.extend(EdgToast))()

    edgToastInstance.$mount()

    Vue.prototype.$edgToast = edgToastInstance
  }
}
